import axios from "axios";
import axiosRetry from 'axios-retry';

export const API = (opts = {}, optsHeader = {}) => {
  /*
  |--------------------------------------------------
  | Custom axios api
  |--------------------------------------------------
  */
  const defaultOptions = {
    ...opts,
    headers: {
      ...optsHeader,
    },
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  };

  let baseURL = `${process.env.REACT_APP_API_URL}/api/v1`;
  const axiosApi = axios.create({
    baseURL,
    ...defaultOptions,
  });
  
  axiosRetry(axiosApi, {
    retries: 3,
    retryCondition(error) {
      if (error) {
        return true;
      }

      return false;
    },
  });

  axiosApi.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    throw new Error(error);
  });

  return axiosApi;
};
